import type { ErrorEvent, EventHint } from '@sentry/types';
import type { MentiError } from '@mentimeter/error-utils/error';

export function errorMiddleware(
  middleware: (
    event: ErrorEvent,
    hint: EventHint,
    originalException: Error,
  ) => ErrorEvent | null,
) {
  return (event: ErrorEvent, hint: EventHint): ErrorEvent | null => {
    if (
      event.environment === 'dev' &&
      process.env.LINKUP_LOG_LEVEL &&
      process.env.LINKUP_LOG_LEVEL !== 'silent'
    ) {
      // eslint-disable-next-line no-console
      console.warn('[Mentimeter] Sentry exception received:', event, hint);
    }

    if (!hint.originalException) {
      // Without an original exception, there's very little to go on
      // Don't send to Sentry
      return null;
    }

    const originalException =
      typeof hint.originalException === 'string'
        ? ({ message: hint.originalException } as MentiError)
        : (hint.originalException as MentiError);

    if (originalException.feature) {
      event.tags = {
        ...event.tags,
        feature: originalException.feature,
      };
    }

    event.tags = {
      ...originalException.tags,
      ...event.tags,
    };

    return middleware(event, hint, originalException);
  };
}
